const routes = {
  ACCESS_DENIED: "/access-denied",
  NOT_FOUND: "/not-found",
  AUTH_ROOT: "auth",
  AUTH: {
    FORGOT_PASSWORD: "/auth/forgot-password",
    SIGN_IN: "/auth/sign-in",
    SIGN_UP: "/auth/sign-up",
    ACCEPT_TERMS_AND_COND: "/auth/accept-terms",
    COMPLAINTS: "/auth/complaints",
  },
  APP_ROOT: "app",
  HOME: "home",
  SETTING_ROOT: "setting",
  SETTING: {
    PERSONAL_DETAIL: "setting/personal-detail",
    ADDRESS_DETAIL: "setting/address-detail",
    MARITAL_STATUS: "setting/marital-status",
    TERMS_AND_CONDITION: "setting/terms-and-condition",
    ELIGIBILITY: "setting/eligibility",
    CONTACT_US: "setting/contact-us",
    DOCUMENT: "setting/document",
    FAQ: "setting/faq",
    CHANGE_PASSWORD: "setting/change-password",
    MANAGE_OFFERS: "setting/manage-offers",
    INSTLMNT_DASHBOADRD: "setting/instlmnt-dashboard",
    SALARY_INFO: "setting/salary-info",
  },
  CREATE_REQUEST: "create-request",
  CREATE_REQUEST_PERSONAL_DETAILS: "personal-details",
  CREATE_REQUEST_EMPLOYMENT_DETAILS: "employment-details",
  CREATE_REQUEST_FINANCIAL_DETAILS: "financial-details",
  CREATE_REQUEST_LOAN_DETAILS: "loan-details",
  CREATE_REQUEST_AUTO_LOAN: "auto-loan",
  CREATE_REQUEST_DOCUMENT_DETAILS: "document-details",
  UPLOAD_ADDITIONAL_DOCUMENT: "upload-document",
  CREATE_REQUEST_GUARANTORS_DETAILS: "guarantors-details",
  CREATE_REQUEST_SUCCESS: "success",
  REQUEST_DETAILS: "request-details",
  VIEW_REQUEST: "view-request",
  VIEW_OFFER: "view-offer",
  VIEW_CONTRACT: "view-contract",
  PRE_APP: "pre",
  PARTNERS: "partners",
  VOUCHERS: "vouchers",
  PRODUCTS: "products",
  SCHOOLS: "schools",
  DENTAL: "dental",
  // V2 dynamic-vendor paths — render the same product flow but driven by /v2/vendors API.
  // Legacy SCHOOLS/DENTAL stay live; flip Home over by swapping FeaturedProducts -> FeaturedProductsV2.
  SCHOOLS_V2: "schools-v2",
  DENTAL_V2: "dental-v2",
  // Static "Other Services" catalog (Loan Restructure, Topup, …) — hardcoded for
  // now, backend-driven later. Home carousel + list page at OTHER_SERVICES + "/list".
  OTHER_SERVICES: "other-services",
  MERCHANTS: {
    SHERIZERO: "sheri0/merchants",
    SHERI: "sheri/merchants"
  },
};

export const appRoute = (route) => `/${routes.APP_ROOT}/${route}`;

export const authRoute = (route) => `/${routes.AUTH_ROOT}/${route}`;

export const createRequestRoute = (route) =>
  `/${routes.APP_ROOT}/${routes.CREATE_REQUEST}/${route}`;

export default routes;
